import axios from "axios";
import { Base_URL } from "../url";

export const fetchItemGroups2 = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemGroup2/GetAllItemGroup2`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item groups 2!";
  }
};

export const downloadItemGroups2Excel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup2/DownloadItemGroup2Excel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading item groups 2 data!";
  }
};